// src/services/ability.js
import { AbilityBuilder, Ability } from "@casl/ability";
import { PERMISSIONS } from "@/constant/permissions.js";

const freeAccessRoutes = [
  "NotFound",
  "home",
  "profile",
  "connected-devices",
  "identity-verification",
  "financial",
  "forbidden",
  "discord-otp",
  "Wallet",
];

export function createAbility(permissions) {
  const { can, rules } = new AbilityBuilder(Ability);

  can("manage", freeAccessRoutes);

  permissions.forEach((permission) => {
    switch (permission) {
      case "BIG_BOSS":
        can("manage", "all");
        break;
      case PERMISSIONS.DEVELOPER:
        can("manage", ["upload-project"]);
        break;
      case "KYC_MANAGEMENT":
        can("manage", ["verify-kyc", "verify-user"]);
        break;
      case "ORDERS_ACCOUNT_ACCESS":
        can("manage", [
          "account-hot-orders",
          "games-account",
          "account-orders",
          "account-order-details",
        ]);
        break;
      case "ORDERS_ACCOUNT_UPDATE":
        can("manage", ["account-order-add"]);
        break;
      case "ORDERS_BOOST_ACCESS":
        can("manage", [
          "boost-hot-orders",
          "games-boost",
          "boost-orders",
          "boost-order-details",
        ]);
        break;
      case "ORDERS_BOOST_UPDATE":
        can("manage", ["boost-order-add", "boost-hot-orders", "updatedog"]);
        break;
      case "ORDERS_CURRENCY_ACCESS":
        can("manage", [
          "currency-buy-hot-orders",
          "currency-sell-hot-orders",
          "games-currency-buy",
          "games-currency-sell",
          "currency-buy-orders",
          "currency-sell-orders",
          "currency-sell-order-details",
          "currency-buy-order-details",
        ]);
        break;
      case "ORDERS_CURRENCY_UPDATE":
        can("manage", [
          "currency-buy-order-add",
          "currency-sell-order-add",
          "currency-buy-ads",
        ]);
        break;
      case "ORDERS_ITEM_ACCESS":
        can("manage", ["item-orders", "item-order-details"]);
        break;
      case "ORDERS_ITEM_UPDATE":
        can("manage", ["item-order-add"]);
        break;
      case "ORDERS_GIFT_CARD_ACCESS":
        can("manage", ["gift-card-orders", "gift-card-order-details"]);
        break;
      case "ORDERS_GIFT_CARD_UPDATE":
        can("manage", ["gift-card-order-add"]);
        break;
      case "ORDERS_SHOP_ACCESS":
        can("manage", ["shop-order-details", "shop-orders"]);
        break;
      case "ORDERS_SHOP_UPDATE":
        can("manage", ["shop-order-add"]);
        break;
      case "GAME_ACCOUNTS_ACCESS":
        can("manage", ["games-account", "game-accounts-list"]);
        break;
      case "GAME_BOOST_ACCESS":
        can("manage", "games-boost");
        break;
      case "GAME_CURRENCY_ACCESS":
        can("manage", ["games-currency-buy", "games-currency-sell"]);
        break;
      case "ADMIN":
        can("manage", ["Users", "calculator"]);
        break;
      case PERMISSIONS.CUSTOMER_SESSIONS:
        can("manage", "customer-session");
        break;
      case "STORES_MANAGER_ACCESS":
        can("manage", "management-stores");
        break;
      case "STOCKS_MANAGER_ACCESS":
        can("manage", [
          "stocks-overview",
          "new-transfer",
          "stocks-servers",
          "stocks-new-transfer",
          "stocks-orders",
          "stocks-gold",
          "stocks-order-details",
          "stocks-orders-add",
          "stocks-supplier",
          "stocks-supplier-game",
          "stocks-supplier-settings",
        ]);
        break;
      case "AUTOMATIONS_WATCHDOG_CURRENCY":
        can("manage", ["market-map"]);
        break;
      case "CURRENCY_PRICING_ACCESS":
        can("manage", ["in-game-currency-pricing"]);
        break;
      case "AUTOMATIONS_WATCHDOG_ACCESS":
        can("manage", ["watchdog-boost"]);
        break;
      case "CHATS_ACCESS":
        can("manage", "chat");
        break;
      case "AI_ASSISTANT_ACCESS":
        can("manage", ["ChatGpt", "add-chatgpt", "gpt-details"]);
        break;
      default:
        can("manage", freeAccessRoutes);
    }
  });

  return rules; // Return the rules array
}
